import { render, staticRenderFns } from "./MenuCouponIcon.vue?vue&type=template&id=20022496&"
import script from "./MenuCouponIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuCouponIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports